import {inject, InjectionToken} from '@angular/core';
import {API_URL} from '@aviary/injection-tokens/app-provided.tokens';
import {ControlRef, FormRowRef} from '@aviary/forms/fields/form-fields.types';
import {RouteNameCapableButtonComponent} from '@aviary/buttons/button.types';

////
//// This file defines injection tokens that are provided in Aviary and used only by Aviary.
////
//// Individual apps should not need to provide them, nor should they need to know anything about them.
////

export const CHILI_FRESH_ORIGIN: InjectionToken<string> = new InjectionToken<string>(
  'CHILI_FRESH_ORIGIN',
  {providedIn: 'root', factory: () => 'https://content.chilifresh.com/'}
);

export const CHILI_FRESH_IMAGE_SIZE: InjectionToken<string> = new InjectionToken<string>(
  'CHILI_FRESH_IMAGE_SIZE',
  {providedIn: 'root', factory: () => 'M'}
);

export const CHILI_FRESH_BASE_URL: InjectionToken<string> = new InjectionToken<string>(
  'CHILI_FRESH_BASE_URL',
  {providedIn: 'root', factory: () => inject(CHILI_FRESH_ORIGIN)}
);

export const BOWKER_ORIGIN: InjectionToken<string> = new InjectionToken<string>(
  'BOWKER_ORIGIN',
  {providedIn: 'root', factory: () => new URL('/', inject(API_URL)).origin}
);

export const BOWKER_BASE_URL: InjectionToken<string> = new InjectionToken<string>(
  'BOWKER_BASE_URL',
  {providedIn: 'root', factory: () => new URL('/public/v1/content/images/bowker/ean/', inject(API_URL)).href}
);

export const CONTROL_REF: InjectionToken<ControlRef> = new InjectionToken<ControlRef>('CONTROL_REF');

export const FORM_ROW_REF: InjectionToken<FormRowRef> = new InjectionToken<FormRowRef>('FORM_ROW_REF');

export const ROUTE_NAME_CAPABLE_BUTTON_COMPONENT = new InjectionToken<RouteNameCapableButtonComponent>('ROUTE_NAME_CAPABLE_BUTTON_COMPONENT');
